export const getUniqueStr = (strong?: number): string => {
  if (!strong) {
    strong = 1000;
  }
  return new Date().getTime().toString(10) + Math.floor(strong * Math.random()).toString(16);
};
